// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--ef413","heading":"heading--3fa25"};